window.addEventListener('change', (event) => {

	const tagName = event.target.tagName.toLowerCase(); // Get tag name in lowercase
	const className = event.target.className;

	if (className.includes('product-variant-id') && `${tagName}.${className}` == "input.product-variant-id") {
		const targetVariantId = event.target.value;
		const pVars = getProductVariants();
		if (pVars && pVars.length>0) {
			var selectedVariant = pVars.find(variant => variant.id == targetVariantId);
			
			if (selectedVariant.inventory_quantity > 0) {
				//product variant in stock.  remove price spider lookup
				removePriceSpiderWTB();

			}else{
				var barcode = selectedVariant.barcode;
				if(!barcode){
					//fetch first product variant with a barcode
					console.log(`No barcode for variantId := (${targetVariantId}) sku := ${selectedVariant.sku} fetching closest product with barcode available.`);
					barcodeVariant = getFirstVariantWBarCode(pVars);
					selectedVariant = barcodeVariant;
				}
	
				if (selectedVariant) { //either selected variant OR nearest variant that is purchaseable in store (has a barcode)
					reBindPriceSpider(selectedVariant.sku);
				}
			}
		}
	}

});

function getFirstVariantWBarCode(pVars) {
	const selectedVariant = pVars.find(variant => variant.barcode);
	return selectedVariant;
}

// Function to extract JSON data from the script tag
function getProductVariants() {
	var productData;

	const scriptTag = document.getElementById('pVars');
    if (scriptTag) {
        var jsonString = scriptTag.textContent;
        productData = JSON.parse(jsonString);
    }

    return productData;
}

function removePriceSpiderWTB(){
	const container = document.querySelector('.ps-widget__container');
	if (container) {
        while (container.firstChild) {
            container.removeChild(container.firstChild);
        }
    }
}

function reBindPriceSpider(sku) {
	const psconfig = document.querySelector('psconfig'); // Find the <psconfig> element
	if (psconfig) {
	  var ps_config_pdp = psconfig.getAttribute('ps-config-pdp');
	  console.log('ps-config:', ps_config_pdp);
	}
	
	removePriceSpiderWTB(); //remove any previous version of Price Spider Where To Buy and we will re-build it
	const container = document.querySelector('.ps-widget__container');
    if (container) {
        const newLink = document.createElement('a');
        newLink.className = 'ps-widget product-form__submit button--full-width button--secondary';
        newLink.setAttribute('ps-sku', sku);
        newLink.setAttribute('ps-config', ps_config_pdp);
        container.appendChild(newLink);
    }
    
    // Check if PriceSpider exists before attempting to use it
	if (typeof PriceSpider !== 'undefined' && PriceSpider.rebind) {
		PriceSpider.rebind();
	}
	
		// Get all elements with the class 'ps-widget__container'
	const psWidgetContainers = document.querySelectorAll('.ps-widget__container');

	// Loop through each container and attach the click event handler
	psWidgetContainers.forEach(container => {
		// Remove any existing click event listeners
		container.replaceWith(container.cloneNode(true));

		// Add the new click event listener
		container.addEventListener('click', function(event) {
			// Find the child element with the class 'ps-widget' and trigger its click event
			const psWidget = this.querySelector('.ps-widget');
			if (psWidget) {
				psWidget.click();
			}
		});
	});
}